import type { FC } from 'react';
import type { Match, WrestlerInMatch } from '../../../types';
import { BoxWhenFatalorTagMatchContainer, DefaultContainerCard, RowOpponentWhenTwoWrestlerInBox, TopDecorColor } from './GenericComponentCssMatchCard';
import CenterInfoFightComponentRender, { AvatarWrestlerWhenThreeOrFourWrestlerInMatch } from './GenericComponentMatchCard';

interface FatalMatchCardProps {
    matchInfo: Match;
    keyMatchInfo: number | string;
    navigateToWrestler: (wrestler: WrestlerInMatch) => void;
}

const FatalMatchCard: FC<FatalMatchCardProps> = ({ matchInfo, keyMatchInfo, navigateToWrestler }) => {
  return (
    <DefaultContainerCard>
        <TopDecorColor />

        <BoxWhenFatalorTagMatchContainer className="box-team-container-left left">

            <RowOpponentWhenTwoWrestlerInBox className="row-opponent">
                <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                    wrestler={matchInfo.wrestlers[0]}
                    win_by_dq={matchInfo.win_by_dq}
                    navigateToWrestler={navigateToWrestler}
                />
                <h6 className="opponent-name">{matchInfo.wrestlers[0].name}</h6>
            </RowOpponentWhenTwoWrestlerInBox>

            <RowOpponentWhenTwoWrestlerInBox className="row-opponent">
                <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                    wrestler={matchInfo.wrestlers[1]}
                    win_by_dq={matchInfo.win_by_dq}
                    navigateToWrestler={navigateToWrestler}
                />
                <h6 className="opponent-name">{matchInfo.wrestlers[1].name}</h6>
            </RowOpponentWhenTwoWrestlerInBox>

        </BoxWhenFatalorTagMatchContainer>

        <CenterInfoFightComponentRender nameMatch="Fatal 4-Way" matchInfo={matchInfo} />

        <BoxWhenFatalorTagMatchContainer className="box-team-container-right right">

            <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-right">
                <h6 className="opponent-name">{matchInfo.wrestlers[2].name}</h6>
                <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                    wrestler={matchInfo.wrestlers[2]}
                    win_by_dq={matchInfo.win_by_dq}
                    navigateToWrestler={navigateToWrestler}
                />
            </RowOpponentWhenTwoWrestlerInBox>

            <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-right">
                <h6 className="opponent-name">{matchInfo.wrestlers[3].name}</h6>
                <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                    wrestler={matchInfo.wrestlers[3]}
                    win_by_dq={matchInfo.win_by_dq}
                    navigateToWrestler={navigateToWrestler}
                />
            </RowOpponentWhenTwoWrestlerInBox>

        </BoxWhenFatalorTagMatchContainer>

        </DefaultContainerCard>
  );
};

export default FatalMatchCard;
